import {createFetchClientWithAuth} from '../util/request/middleware'
import Config from '../../lib/config'

const client = createFetchClientWithAuth(Config.CLIENT_WEB)

/**
 * Syncs the identity server token with php
 * @param token
 * @return {Boolean}
 */
export function syncToken(token){
	return client.post('login/tokenToSession', {
		credentials: 'include', // Cookies don't get passed without this
		withCredentials: true,
		body: {
			token
		}
	})
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/legacyWebsite.js